<template>
  <v-container fluid>
    <v-layout row>
      <v-flex>
        <v-card>
          <v-card-title primary-title class="primary white--text headline">
            Scheduled Jobs
            <v-spacer></v-spacer>
            <v-btn medium depressed flat icon color="white" to="scheduled-jobs/add" v-if="$auth.user().AuthScope.includes('job:manage')">
              <v-icon medium>add_circle_outline</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pa-0">
            <v-data-table
            :headers="headers"
            :items="items"
            :rows-per-page-items="[25,50,100,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
            :loading="scheduledJobsLoading">
              <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
              <template slot="items" slot-scope="props">
                <td>{{ props.item.id }}</td>
                <td>{{ props.item.topicModelName }}</td>
                <td v-if="props.item.solrName.length">
                  <v-chip
                  class="white--text"
                  small
                  color="accent">
                    {{ props.item.solrName.join(', ') }}
                  </v-chip>
                </td>
                <td v-else>{{ props.item.datasetName }}</td>
                <td>{{ jobTypesCollection[props.item.type] }}</td>
                <td>{{ jobStatusCollection[props.item.status] }}</td>
                <td>{{ props.item.createdDate | formatDate }}</td>
                <td>{{ props.item.lastRunDate | formatDate }}</td>
                <td>{{ props.item.nextRunDate | formatDate }}</td>
                <td class="text-xs-right">
                  <v-tooltip bottom color="success" v-if="$auth.user().AuthScope.includes('job:manage')">
                    <v-icon
                      color="success"
                      slot="activator"
                      @click="itemToCommand = props.item; itemCommand(2)"
                    >
                      play_arrow
                    </v-icon>
                    <span>Run</span>
                  </v-tooltip>
                  <v-tooltip bottom color="orange" v-if="$auth.user().AuthScope.includes('job:manage') && jobStatusCollection[props.item.status] == 'Paused'">
                    <v-icon
                      color="orange"
                      slot="activator"
                      @click="itemToCommand = props.item; itemCommand(1)"
                    >
                      skip_next
                    </v-icon>
                    <span>Resume</span>
                  </v-tooltip>
                  <v-tooltip bottom color="orange" v-if="$auth.user().AuthScope.includes('job:manage') && jobStatusCollection[props.item.status] != 'Paused'">
                    <v-icon
                      color="orange"
                      slot="activator"
                      @click="itemToCommand = props.item; itemCommand(0)"
                    >
                      pause
                    </v-icon>
                    <span>Pause</span>
                  </v-tooltip>
                  <v-tooltip bottom color="secondary"
                    v-if="[1, 2, 3, 4].includes(props.item.type)">
                    <v-icon
                      class="mr-2"
                      color="secondary"
                      slot="activator"
                      @click="$router.push(`/scheduled-jobs/${props.item.id}/logs`)"
                      >
                      receipt
                    </v-icon>
                    Show Logs
                  </v-tooltip>
                  <v-tooltip bottom color="primary"
                    v-if="props.item.type === 16">
                    <v-icon
                      class="mr-2"
                      color="primary"
                      slot="activator"
                      @click="downloadScored(props.item)"
                      >
                      cloud_download
                    </v-icon>
                    Download Scored File
                  </v-tooltip>
                  <v-tooltip bottom color="accent" v-if="$auth.user().AuthScope.includes('job:manage')">
                    <v-icon
                      class="mr-2"
                      color="accent"
                      slot="activator"
                      @click="$router.push(`/scheduled-jobs/${props.item.id}/edit`)"
                    >
                      edit
                    </v-icon>
                    <span>Edit Item</span>
                  </v-tooltip>
                  <v-tooltip bottom color="error" v-if="$auth.user().AuthScope.includes('job:manage')">
                    <v-icon
                      color="error"
                      slot="activator"
                      @click="dialog = true; itemToDelete = props.item;"
                    >
                      delete
                    </v-icon>
                    <span>Delete Item</span>
                  </v-tooltip>
                </td>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog
    v-model="dialog"
    max-width="500"
    v-if="$auth.user().AuthScope.includes('job:manage')"
    >
      <v-card>
        <v-card-title class="headline">Delete scheduled job</v-card-title>
        <v-card-text>
          Are you sure to delete this scheduled job?
        </v-card-text>
        <v-card-actions style="background: hsl(0, 0%, 97%)" class="pa-3">
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-1"
            flat
            depressed
            :disabled="deleteLoading"
            @click="dialog = false; itemToDelete = {};"
          >
            Cancel
          </v-btn>
          <v-btn
            color="error"
            depressed
            class="white--text"
            :loading="deleteLoading"
            :disabled="deleteLoading"
            @click.native="deleteItem()"
          >
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
    v-model="logsDialog"
    persistent
    scrollable
    width="900"
    >
      <v-card>
        <v-card-title primary-title class="primary white--text headline">Logs</v-card-title>
        <v-card-text>
          <ul>
            <li v-for="(log, i) in logsToShow" :key="i">
              {{ log }}
            </li>
          </ul>
        </v-card-text>
        <v-card-actions style="background: hsl(0, 0%, 97%)" class="pa-3">
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-1"
            flat
            depressed
            @click="logsToShow = []; logsDialog = false;"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data () {
    return {
      headers: [
        {text: 'ID', sortable: true, value: 'id'},
        {text: 'Topic Model', sortable: true, value: 'topicModelName'},
        {text: 'Dataset', sortable: false, value: 'datasetName'},
        {text: 'Type', sortable: false, value: 'type'},
        {text: 'Status', sortable: false, value: 'status'},
        {text: 'Created', sortable: false, value: 'createdDate'},
        {text: 'Last Run', sortable: false, value: 'lastRunDate'},
        {text: 'Next Run', sortable: false, value: 'nextRunDate'},
        {text: 'Actions', value: 'name', sortable: false, align: 'right'}
      ],
      items: [],
      dialog: false,
      logsDialog: false,
      logsToShow: [],
      itemToDelete: {},
      itemToCommand: {},
      deleteLoading: false,
      scheduledJobsLoading: false,
      commandLoading: false,
      pagination: {
        sortBy: 'id'
      }
    }
  },
  computed: {
    ...mapState({
      jobStatusCollection: state => state.configurations.jobStatusDictionary,
      jobTypesCollection: state => state.configurations.jobTypesDictionary
    })
  },
  created () {
    this.scheduledJobsLoading = true
    this.fetchJobs()
  },
  methods: {
    fetchJobs () {
      this.axios.get('/jobs')
        .then(response => {
          if (response.data) {
            this.items = response.data.map(job => ({
              id: job.id,
              solrName: job.target_solr_core_names,
              datasetName: job.dataset ? job.dataset.name : '-',
              topicModelName: job.topic_model ? job.topic_model.name : '-',
              status: job.status,
              type: job.job_type,
              createdDate: job.created_date,
              lastRunDate: job.last_run,
              nextRunDate: job.next_run_time,
              logs: job.logs
            }))
          }
        })
        .catch(error => {
          this.handleAxiosError(error)
        })
        .finally(() => {
          this.scheduledJobsLoading = false
        })
    },
    deleteItem () {
      this.deleteLoading = true
      this.axios.delete(`/jobs/${this.itemToDelete.id}`)
        .then(response => {
          let index = this.items.indexOf(this.itemToDelete)
          this.items.splice(index, 1)
        })
        .catch(error => {
          this.handleAxiosError(error)
        })
        .finally(() => {
          this.deleteLoading = false
          this.dialog = false
          this.itemToDelete = {}
        })
    },
    itemCommand (command) {
      this.scheduledJobsLoading = true
      this.axios.post(`/jobs/${this.itemToCommand.id}/command`, {command: command})
        .then(response => {
          this.fetchJobs()
        })
        .catch(error => {
          this.handleAxiosError(error)
        })
        .finally(() => {
          this.itemToCommand = {}
          this.scheduledJobsLoading = false
        })
    },
    downloadScored (item) {
      this.axios.get(`/jobs/${item.id}/download-scored`, { responseType: 'blob' })
        .then(response => {
          const disposition = response.headers['content-disposition'] || ''
          let filename = `scored_${item.id}.xlsx`
          const match = disposition.match(/filename=([^;]+)/i)
          if (match && match[1]) {
            filename = match[1].trim().replace(/^"|"$/g, '')
          }
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
          link.remove()
          window.URL.revokeObjectURL(url)
        })
        .catch(error => {
          this.handleAxiosError(error)
        })
    }
  }
}
</script>

<style>

</style>
